import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
export var AUTOMATIC = 'automatic';
export var MANUAL = 'manual';
var i18nLabels = _defineProperty(_defineProperty({}, AUTOMATIC, 'mark_as_done_automatic'), MANUAL, 'mark_as_done_manual');
export var MODES = [AUTOMATIC, MANUAL].map(function (mode) {
  return {
    value: mode,
    i18nTitleKey: i18nLabels[mode]
  };
});
export function getModeI18nLabel(mode) {
  return i18nLabels[mode] || null;
}